
import React from "react";
import { Label } from "@/components/ui/label";
import NumericInput from "@/components/ui/NumericInput";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";
import { formatCurrency, parseCurrency } from "../../utils/formatters";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface HOAFeeInputProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const HOAFeeInput: React.FC<HOAFeeInputProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Monthly HOA Fee <MetricTooltip metric="hoaFees" /></Label>
        <NumericInput
          value={mortgageData.hoaFees}
          onChange={(value) => {
            setMortgageData(prev => calculateMortgageData({
              ...prev,
              hoaFees: value
            }));
          }}
          formatValue={formatCurrency}
          parseValue={parseCurrency}
          min={0}
          max={99999}
          className="w-full sm:w-48"
          inputClassName="text-right overflow-ellipsis"
        />
      </div>
    </div>
  );
};

export default HOAFeeInput;
